module.exports = __webpack_public_path__ + "media/components/wind-icon/static/E@2x-fb4a2603d465049a07b21224b9f9a64e.png";